export const getIsLoading = (state) => state.contact.isLoading
export const getSubmitStatus = (state) => state.contact.submitStatus
